import React, { useEffect, useState } from 'react';
import { MdOutlineMessage } from 'react-icons/md';
import { RiRefreshLine } from 'react-icons/ri';
import Swal from 'sweetalert2';
import { useAlerts } from '../../../../hooks/useAlerts';
import { sqlDateFormat } from '../../../../utils/Common';
import NotifyC from '../../../../components/Notifications';
import Spinner from '../../../../components/Spinner';

const MessageAlerts = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [reload, setReload] = useState(false);
  const { getAlertsNoRead, readAlerts } = useAlerts();

  const handleGetMessageUser = async () => {
    const abortController = new AbortController();
    try {
      const response = await getAlertsNoRead(abortController.signal);   
      const dataOrder = response.sort((a, b) => new Date(b?.FechaRegistro) - new Date(a?.FechaRegistro));   
      setMessages(dataOrder);
    } catch (error) {
      setMessages([]); 
      console.error('Error fetching messages:', error);
    } finally {
      setLoading(false); 
    }
  };

  const handleReloadMessages = async () => {
    setReload(true); 
    
    await handleGetMessageUser();
     
    NotifyC.success('Mensajes actualizados.', { duration: 3000, position: 'top-right' });

    setReload(false); 
  }

  const handleReadMessage = async (index) => {
    const confirm = await Swal.fire({
      title: '¿Marcar como leído?',
      text: '¿Deseas marcar esta alerta como leído?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: "white",
      cancelButtonColor: "black",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      customClass: {
          confirmButton: 'custom-confirm-button',
          cancelButton: 'custom-cancel-button',
      },
    });

    if (confirm.isConfirmed) {
      const message = messages[index];

      const dataToSend = { id: message.IdAlertas, type: 2 };

      try {
        const abortController = new AbortController();
        const response = await readAlerts(abortController.signal, dataToSend);

        if (response.code === 200){
          const updatedMessages = messages.filter((_, i) => i !== index);
          setMessages(updatedMessages);
          NotifyC.success(`El mensaje ha sido marcado como leído.`, { duration: 3000, position: 'top-right' });
        } else if (response.code === 404){
          switch (response.message) {
            case 'ALERT_ALREADY_CHECKED':
              NotifyC.error('El mensaje ya ha sido marcado como leído.', { duration: 3000, position: 'top-right' });
              break;
            case 'ERROR_READ_ALERTS':
              NotifyC.error('Hubo un error al marcar el mensaje', { duration: 3000, position: 'top-right' });
              break;
            default:
              NotifyC.error('Error al marcar el mensaje como leído.', { duration: 3000, position: 'top-right' });
              break;
          }
        }
       
      } catch (error) {
        console.error('Error reading message:', error);
        NotifyC.error('Error al marcar el mensaje como leído.', { duration: 3000, position: 'top-right' });
      }
    }
  };

  useEffect(() => {
    handleGetMessageUser();
  }, []);

  return (
    <div className="dashboardCard m-0 py-6 w-100 h-100">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="text-left"><MdOutlineMessage /> Mensajes</h5>
        <RiRefreshLine 
          size={24} 
          style={{ cursor: "pointer", animation: reload ? "spin 2s linear infinite" : "none" }} 
          onClick={handleReloadMessages} 
        />
      </div>
      <hr />
      <div className="box-message">
        {loading ? (
          <div className='mt-5'>  <Spinner  type={2} size={30} /></div> 
        ) : messages.length === 0 ? (
          <div>No hay mensajes disponibles</div>
        ) : (
          messages.map((item, index) => (
            <div 
              className="item-box-message" 
              key={index} 
              onClick={() => handleReadMessage(index)}
            >
              <div className="mr-3 subtitles-amount-dashb font-bold">{sqlDateFormat(item?.FechaRegistro, "date")}</div>
              <div className='item-box-message-description'>{item?.Descripcion}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MessageAlerts;